const WATCHLISTS = {
    DEFAULT: "DEFAULT",
    MYWATCHLIST: "MYWATCHLIST",
    CURRATED: "CURRATED"
}
export default WATCHLISTS